export default {
    All: 1,
    UNREAD: 2,
    OPT_OUT: 3,
    CLOSED: 4,
    LEAD: 5,
    COLD_LEAD: 6
};
